<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'SIMULATION' | translate}}</span>
            </div>
            <div>
                <button mat-raised-button (click)="simulation=!simulation">
                    <mat-icon>{{this.simulation?'pause':'play_arrow'}}</mat-icon>
                    {{this.simulation?("STOP"|translate):("START"|translate)}}</button>
            </div>

            <!-- / APP TITLE -->
        </div>
        <!-- / HEADER -->
        <div *ngIf="selectCarControl!=null" [hidden]="car == null" class="content-card  my-20">
            <div class="map-container">
                <div class="map-frame">
                    <div id="map">
                        <div mat-dialog-actions align="end">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectCarControl==null" class="content-card my-20">
            <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="height: 100%;">
            <div class="w-30-p">
                <h3>{{'SELECT_CAR'|translate}}</h3>
            </div>
            <mat-form-field appearance="outline" floatLabel="always" class="w-30-p">
                <mat-label>{{'SELECT_CAR'|translate}}</mat-label>
                <mat-select [(ngModel)]="selectCar" required name="companies">
                    <mat-option *ngFor="let item of cars" [value]="item">
                        {{item.plate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="w-30-p" fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-raised-button type="button" (click)="ngAfterViewInit()">{{'APPROVE'|translate}}</button>
            </div>
        </div>
        </div>
        <div>
        </div>
    </div>
    <!-- / CENTER -->
</div>